// extracted by mini-css-extract-plugin
export default {"root":"HeaderWrapperV8_root__tkP8v","draggableHeader":"HeaderWrapperV8_draggableHeader__2TOpk"};